import { Star, ExternalLink } from "lucide-react";
import { FaGoogle } from "react-icons/fa";
import { Reveal, SectionHead } from "@/components/Reveal";
import { TESTIMONIALS, GOOGLE_REVIEW_URL } from "@/constants/site";

const Stars = () => (
  <div className="flex gap-1">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-amber text-amber" />
    ))}
  </div>
);

const ReviewsSection = ({ full = false }) => {
  const list = full ? TESTIMONIALS : TESTIMONIALS.slice(0, 3);
  return (
    <section className="bg-[#F8F9FA] py-20 sm:py-28" data-testid="reviews-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHead
          eyebrow="Social Proof"
          title="Tarrant County trusts Paliway"
          sub="Real stories from drivers we got back on the road."
        />
        <div className="grid gap-5 lg:grid-cols-[340px_1fr]">
          <Reveal>
            <div className="flex h-full flex-col justify-between gap-8 bg-charcoal p-8 grain relative" data-testid="google-rating-card">
              <div>
                <div className="flex items-center gap-2">
                  <FaGoogle className="h-5 w-5 text-white" />
                  <span className="font-mono text-xs tracking-[0.2em] text-zinc-400 uppercase">Google Rating</span>
                </div>
                <p className="mt-6 font-display text-7xl font-black text-white leading-none">
                  5.0<span className="text-emergency">★</span>
                </p>
                <div className="mt-3"><Stars /></div>
                <p className="mt-4 text-sm text-zinc-400">Rated by drivers across Fort Worth, Arlington & beyond.</p>
              </div>
              <a
                href={GOOGLE_REVIEW_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="leave-a-review-button"
                className="inline-flex items-center justify-center gap-2 bg-emergency py-3.5 font-display text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-emergency-dark"
              >
                Leave a Review <ExternalLink className="h-4 w-4" />
              </a>
            </div>
          </Reveal>
          <div className="grid gap-5 sm:grid-cols-2">
            {list.map((t, i) => (
              <Reveal key={t.name} delay={0.08 + i * 0.06}>
                <figure className="flex h-full flex-col justify-between border border-zinc-200 bg-white p-6 sm:p-7" data-testid={`testimonial-${i}`}>
                  <div>
                    <Stars />
                    <blockquote className="mt-4 text-sm leading-relaxed text-zinc-700">"{t.text}"</blockquote>
                  </div>
                  <figcaption className="mt-5 flex items-center gap-2">
                    <span className="font-display text-base font-bold uppercase text-zinc-900">{t.name}</span>
                    <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-zinc-500">— {t.city}</span>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
